import { TrackerAddFormTemplate } from "../enums/tracker-add-form-template";

export default class FoodTrackerFormTemplate {
    readonly type: TrackerAddFormTemplate.FOOD = TrackerAddFormTemplate.FOOD;
    commonNutrition: string;
}